import React, { useState } from "react"
import { InputReason, OrderRefund } from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import UPDATE_REFUND from "../../../../../graphql/mutations/order/refunds/UpdateRefund"
import { getRefundInput } from "../Helpers/helpers"
import { handleErrorMessages } from "helpers/errors"
import Reason from "../../Reason/Reason"
import { ReasonType } from "lib/types/order"
import { isSkipReason } from "../../../helpers"

type Props = {
  refund: OrderRefund
  refetch: () => void
  orderLoading: boolean
}

const RefundReason = ({ refund, refetch, orderLoading }: Props) => {
  const [reasonType, setReasonType] = useState<ReasonType | undefined>(
    !refund?.reason ? ReasonType.SKIP : undefined
  )

  const [updateRefund, { loading }] = useMutation(UPDATE_REFUND, {
    onCompleted: () => {
      setReasonType(ReasonType.SKIP)
      refetch()
    },
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const addReason = (reason: InputReason) => {
    updateRefund({
      variables: {
        refundId: refund.id,
        input: {
          ...getRefundInput(refund),
          ...(reason.cause && reason.code && !isSkipReason(reasonType) && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateRefund({
      variables: {
        refundId: refund.id,
        input: {
          ...getRefundInput(refund),
          reason: null
        }
      }
    })
  }

  return (
    <Reason
      addReason={addReason}
      removeReason={removeReason}
      reasonType={reasonType}
      setReasonType={setReasonType}
      orderReason={refund?.reason}
      loading={loading}
      orderLoading={orderLoading}
    />
  )
}

export default RefundReason
